import React from 'react';

function ChatInput({
  inputText,
  onInputChange,
  onSubmit
}) {
  return (
    <form onSubmit={onSubmit} className="chat-input-form" data-testid="chat-form">
      <label htmlFor="portfolio-question">Ask about my work</label>
      <div className="chat-input-field">
        <input
          id="portfolio-question"
          type="text"
          value={inputText}
          onChange={onInputChange}
          placeholder="Try “How does FluxTrade handle ambiguity?”"
          className="chat-input"
        />
        <button
          type="submit"
          className="send-button"
          disabled={!inputText.trim()}
          aria-label="Ask question"
        >
          <span>Ask</span>
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" aria-hidden="true">
            <path d="M3 8.5h10M9 4l4.5 4.5L9 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
      <p>Ask about a project, a role, or a technical decision.</p>
    </form>
  );
}

export default ChatInput;
